import { useMutation } from "@tanstack/react-query";
import { service, Threat, useAuthConfig } from "@theprelude/core";
import { notifyError } from "@theprelude/ds";

export type UpdateThreatForm = {
  name: string;
  source_id: string;
  tests: string[];
};

export function useUpdateOwnerThreatContents() {
  const authConfig = useAuthConfig();
  return useMutation({
    mutationFn: async ({
      threat,
      form,
    }: {
      threat: Threat;
      form: UpdateThreatForm;
    }) => {
      await service(authConfig).build.updateThreat({
        threat_id: threat.id,
        name: form.name,
        source_id: form.source_id,
        tests: form.tests.join(","),
      });
    },
    onError: (error) =>
      notifyError({
        message: "Failed to update threat",
        error,
        dismissible: true,
      }),
  });
}
